import { Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { Landing } from "./pages/Landing";
import { SiteDetail } from "./pages/SiteDetail";
import LandingV2 from "./preview/landing-v2";
import SiteDetailV2 from "./preview/site-detail-v2";
import SiteDetailV22 from "./preview/site-detail-v2-2";
import SiteDetailV23 from "./preview/site-detail-v2-3";
import SiteDetailV24 from "./preview/site-detail-v2-4";
import SiteDetailV25 from "./preview/site-detail-v2-5";
import SiteDetailV26 from "./preview/site-detail-v2-6";
import SiteDetailV27 from "./preview/site-detail-v2-7";
import SiteDetailV28 from "./preview/site-detail-v2-8";
import SiteDetailV29 from "./preview/site-detail-v2-9";
import SiteDetailV210 from "./preview/site-detail-v2-10";
import SiteDetailV211 from "./preview/site-detail-v2-11";
import SiteDetailV212 from "./preview/site-detail-v2-12";
import SiteDetailV213 from "./preview/site-detail-v2-13";
import SiteDetailV214 from "./preview/site-detail-v2-14";
import SiteDetailV215 from "./preview/site-detail-v2-15";
import VoiceAiDemo from "./preview/demo/VoiceAiDemo";

export default function App() {
  return (
    <Routes>
      {/* Primary routes — v2 design ist jetzt das offizielle UI.
          Rendered OUTSIDE des alten IT-Dark Layouts, mit eigenem
          ThemeProvider, Language-Selector und Light/Dark-Toggle. */}
      <Route path="/" element={<LandingV2 />} />
      <Route path="/sites/:code" element={<SiteDetailV215 />} />

      {/* Snapshot-Strecke — jede v2-Iteration ist eingefroren erreichbar. */}
      <Route path="/preview/landing-v2" element={<LandingV2 />} />
      <Route path="/preview/sites/:code/v2" element={<SiteDetailV2 />} />
      <Route path="/preview/sites/:code/v2-2" element={<SiteDetailV22 />} />
      <Route path="/preview/sites/:code/v2-3" element={<SiteDetailV23 />} />
      <Route path="/preview/sites/:code/v2-4" element={<SiteDetailV24 />} />
      <Route path="/preview/sites/:code/v2-5" element={<SiteDetailV25 />} />
      <Route path="/preview/sites/:code/v2-6" element={<SiteDetailV26 />} />
      <Route path="/preview/sites/:code/v2-7" element={<SiteDetailV27 />} />
      <Route path="/preview/sites/:code/v2-8" element={<SiteDetailV28 />} />
      <Route path="/preview/sites/:code/v2-9" element={<SiteDetailV29 />} />
      <Route path="/preview/sites/:code/v2-10" element={<SiteDetailV210 />} />
      <Route path="/preview/sites/:code/v2-11" element={<SiteDetailV211 />} />
      <Route path="/preview/sites/:code/v2-12" element={<SiteDetailV212 />} />
      <Route path="/preview/sites/:code/v2-13" element={<SiteDetailV213 />} />
      <Route path="/preview/sites/:code/v2-14" element={<SiteDetailV214 />} />
      <Route path="/preview/sites/:code/v2-15" element={<SiteDetailV215 />} />

      {/* Strategic Demo — isolierte Route fuer den Amazon-US-Call (NFM-96). */}
      <Route path="/demo/voice-ai" element={<VoiceAiDemo />} />

      {/* Legacy IT-Dark Layout — archiviert unter /archive/ erreichbar. */}
      <Route
        path="*"
        element={
          <Layout>
            <Routes>
              <Route path="/archive" element={<Landing />} />
              <Route path="/archive/sites/:code" element={<SiteDetail />} />
            </Routes>
          </Layout>
        }
      />
    </Routes>
  );
}
